// The twenty-odd coordination routes, written as `docs/openapi.json` publishes
// them (mastermind_core-final, branch noche/integra-final, 267 operations).
//
// Relative to the api instance's base, which already ends in `/api/v1`.
//
// NOTHING HERE IS INVENTED. A path that is not in that contract is not in this
// file; if a screen needed one, it went to the README as a question instead.

export const coordinationPaths = {
    catalog: (kind) => `admin/${kind}`,
    // La bandeja: qué está esperando a una persona.
    attention: () => 'admin/attention',

    // La parrilla de puestos y un puesto.
    seats: () => 'admin/coordination/seats',
    seat: (id) => `admin/coordination/seats/${id}`,

    // El historial por cursor y la reconstrucción.
    history: () => 'admin/coordination/history',
    snapshot: () => 'admin/coordination/snapshot',

    // Los tiempos: una tarea, y el agregado sobre un alcance.
    taskMetrics: (id) => `admin/metrics/tasks/${id}`,
    durations: () => 'admin/metrics/durations',

    // Los controles: el estado deseado de un puesto, las órdenes y la decisión
    // de una ronda. `orders` es POST; `control` es GET.
    control: (id) => `admin/agents/${id}/control`,
    orders: (id) => `admin/agents/${id}/orders`,
    roundDecision: (taskId) => `admin/tasks/${taskId}/review-round/decision`,

    // El registro de equipos y puestos, la sexta familia. Se lee acá para que
    // el demo no invente una ruta si alguien la agrega a una pantalla.
    machines: () => 'admin/machines',
    positions: () => 'admin/positions',
};

// The four verbs, and there is no fifth. `POST /admin/agents/{id}/orders`
// takes `verb` from this list and has no field for a command, a script or
// arguments: sending one is a 422 that names it.
export const ORDER_VERBS = ['habilitar', 'pausar_tomas', 'interrumpir', 'reintentar'];

// The six classes of the attention inbox, in the order the catalogue lists
// them. The catalogue travels in every response (`kinds`), so the screen reads
// it from there; this is only for the filter to keep its order before the
// first answer arrives.
export const ATTENTION_KINDS = [
    'permisos_del_proveedor',
    'limite_de_uso',
    'revision_incompleta',
    'reserva_perdida',
    'error_recuperable',
    'equipo_ausente',
];
